var _rect, _rect2, _rect3, _line, _rect4, _circle, _circle2, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankIdentLogoNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 17,
    width: 30,
    height: 20,
    rx: 2.5,
    fill: "#ffffff",
    stroke: "#4b5563",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 21,
    width: 30,
    height: 4,
    fill: "#4b5563"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 29,
    width: 8,
    height: 4,
    rx: 1,
    stroke: "#4b5563",
    strokeWidth: 1.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 31,
    x2: 31,
    y2: 31,
    stroke: "#4b5563",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 11,
    width: 28,
    height: 18,
    rx: 2.5,
    fill: "#ffffff",
    stroke: "#4b5563",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 20,
    r: 3.4,
    stroke: "#4b5563",
    strokeWidth: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 20,
    r: 3.4,
    stroke: "#4b5563",
    strokeWidth: 1.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 16,
    x2: 29,
    y2: 16,
    stroke: "#4b5563",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 20,
    x2: 25,
    y2: 20,
    stroke: "#4b5563",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIdentLogoNoText);
export default __webpack_public_path__ + "static/media/BankIdentLogoNoText.abd48f2b00b3adcef1be9afddc1469e8.svg";
export { ForwardRef as ReactComponent };